import { Typeahead } from "@merge-api/merge-javascript-shared";
import { RadioGroup, Radio } from "@merge-api/merge-javascript-shared";
import { TypeaheadComparatorClusterOption } from "@merge-api/merge-javascript-shared/dist/designSystem/molecules/Typeahead/types/types";
import { Dispatch, SetStateAction } from "react";

interface AlertDashboardFiltersProps {
  activeFilters: TypeaheadComparatorClusterOption[];
  setActiveFilters: (filters: TypeaheadComparatorClusterOption[]) => void;
  availableFilters: TypeaheadComparatorClusterOption[];
  showResolved: boolean;
  setShowResolved: Dispatch<SetStateAction<boolean>>;
  showSilenced: boolean;
  setShowSilenced: Dispatch<SetStateAction<boolean>>;
}

const AlertDashboardFilters = ({
  activeFilters,
  setActiveFilters,
  availableFilters,
  showResolved,
  setShowResolved,
  showSilenced,
  setShowSilenced,
}: AlertDashboardFiltersProps) => {
  return (
    <div className="flex w-full">
      <div className="flex-grow">
        <Typeahead
          key={availableFilters.length} // Changing the key forces the component to refresh.  If we don't do this, the available filters don't get refreshed properly.
          isComparatorClusters
          options={availableFilters}
          blurOnSelect
          value={activeFilters}
          onChange={(_, value) => {
            if (value) {
              setActiveFilters(value);
            }
          }}
          placeholder={activeFilters.length === 0 ? `Filter and search` : ""}
          showSearchIcon
        />
      </div>
      <div className="flex space-x-4 ml-4">
        <RadioGroup
          value={showResolved ? "resolved" : showSilenced ? "silenced" : "active"}
          onValueChange={(value) => {
            if (value === "active") {
              setShowResolved(false);
              setShowSilenced(false);
            } else if (value === "resolved") {
              setShowResolved(true);
              setShowSilenced(false);
            } else if (value === "silenced") {
              setShowResolved(false);
              setShowSilenced(true);
            }
          }}
          className="flex flex-row gap-8"
        >
          <Radio value="active" label="Active" variant="secondary" />
          <Radio value="silenced" label="Muted" variant="secondary" />
          <Radio value="resolved" label="Resolved" variant="secondary" />
        </RadioGroup>
      </div>
    </div>
  );
};

export default AlertDashboardFilters;
